import { useState } from "react";
import Select from "react-select";
import { useAppServices } from "../../../../../../hook/services";
import { useSSOInfo } from "../../../../../../context/sso";
import { Icon } from "@iconify/react";

const CreateTicket = ({ apps = [], handleRefresh }) => {
  const [open, setOpen] = useState(false);
  const AppService = useAppServices();
  const [SSOData] = useSSOInfo();
  const [formData, setFormData] = useState({
    app: null,
    subject: "",
    description: "",
    loomVideo: "",
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFormData({
      app: null,
      subject: "",
      description: "",
      loomVideo: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAppChange = (selectedOption) => {
    setFormData((prev) => ({ ...prev, app: selectedOption }));
  };

  const generateTicketId = () => {
    return "TKT-" + Math.random().toString(36).substr(2, 9).toUpperCase();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    const ticket_id = generateTicketId();
    const payload = {
      companyId: SSOData?.companyId,
      userId: SSOData?.userId,
      userType: SSOData?.type,
      userRole: SSOData?.role,
      userName: SSOData?.userName,
      email: SSOData?.email,
      appRefId: formData?.app?.value,
      appId: formData?.app?.appId,
      subject: formData?.subject,
      description: formData?.description,
      loomVideo: formData?.loomVideo,
      ticket_id,
    };
    const { response } = await AppService.support.create_ticket({ payload });
    if (response) {
      handleRefresh();
      handleClose();
    }
  };

  return (
    <>
      <button
        className="btn btn-primary w-100 shadow-sm d-flex align-items-center justify-content-center gap-2 py-2 fw-semibold"
        onClick={handleOpen}
      >
        <Icon icon="mdi:plus-circle-outline" className="fs-5" />
        Create Ticket
      </button>

      {open && (
        <div
          className="modal fade show d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-md">
            <div className="modal-content border-0 shadow-lg rounded-4">
              {/* Header */}
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold text-dark">
                  Create Support Ticket
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleClose}
                ></button>
              </div>

              {/* Body */}
              <div className="modal-body pt-3">
                <form
                  onSubmit={handleSubmit}
                  className="d-flex flex-column gap-3"
                >
                  {/* App Dropdown */}
                  <div>
                    <label className="form-label fw-semibold">App</label>
                    <Select
                      options={apps.map((app) => ({
                        value: app._id,
                        label: app.appName,
                        appId: app.appId,
                      }))}
                      value={formData.app}
                      onChange={handleAppChange}
                      placeholder="Select an app..."
                      classNamePrefix="react-select"
                    />
                  </div>

                  {/* Subject */}
                  <div>
                    <label className="form-label fw-semibold">Subject</label>
                    <input
                      type="text"
                      className="form-control"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      placeholder="Enter subject"
                      required
                    />
                  </div>

                  {/* Description */}
                  <div>
                    <label className="form-label fw-semibold">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      name="description"
                      value={formData.description}
                      onChange={handleChange}
                      placeholder="Describe your issue"
                      rows="4"
                      required
                    ></textarea>
                  </div>

                  {/* Loom Video */}
                  <div>
                    <label className="form-label fw-semibold">
                      Loom Video (optional)
                    </label>
                    <input
                      type="url"
                      className="form-control"
                      name="loomVideo"
                      value={formData.loomVideo}
                      onChange={handleChange}
                      placeholder="Paste Loom video link"
                    />
                  </div>
                </form>
              </div>

              {/* Footer */}
              <div className="modal-footer border-top-0 pt-0 d-flex justify-content-end gap-2">
                <button
                  type="button"
                  className="btn btn-light px-4"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4"
                  onClick={handleSubmit}
                >
                  Submit Ticket
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CreateTicket;
